
import { Component, Vue, Prop } from "vue-property-decorator";
import { GameType, GAMETYPE_ID } from "@/models/GameType";
import { values } from "lodash";
import AddSeason from "./AddSeason.vue";

@Component({
  components: {
    AddSeason,
  },
})
class GameTypeTable extends Vue {
  @Prop({ default: false }) readonly isEditing!: boolean;
  items = [];
  searchFilter = "";
  busy = false;
  fields = [
    {
      key: "name",
      label: "Name",
      sortable: true,
    },
  ];
  gametypeSelect = {
    options: values(GAMETYPE_ID).filter(
      (value) => typeof value === "string" && value !== "manhunt"
    ), // * Get all the gameTYpes as a stringArr
    selected: this.getGameTypeID,
  };

  get getGameTypeID(): GAMETYPE_ID {
    if (this.$store.state.gameStore.gameType.length > 0)
      return this.$store.state.gameStore.gameTypeSelected;
    return GAMETYPE_ID.QUEST;
  }

  get getGameTypes(): GameType[] {
    return this.$store.state.gameStore.gameType;
  }
  created(): void {
    this.busy = true;
    this.$store.commit("gameStore/gameTypeSelect", this.getGameTypeID);
    this.$store
      .dispatch("gameStore/getGameTypes", this.getGameTypeID)
      .then(() => {
        this.busy = false;
      });
  }
  onRowSelected(rows: any): void {
    if (rows.length < 1) return;
    this.$emit("handleGameTypeSelection", rows[0]);
  }
  filterByGameTypeName(row: any, filter: never): boolean {
    if (row.name.en.toLowerCase().includes(this.searchFilter.toLowerCase())) {
      return true;
    }
    return false;
  }

  openAddSeason(): void {
    this.$bvModal.show("team-modal-add-season");
  }
  setOptionSelected(value: string): void {
    this.$emit("handleCloseSelection");
    this.$store.commit("gameStore/gameTypeSelect", value);
    this.$store.dispatch("gameStore/getGameTypes", value);
  }
}

export default GameTypeTable;
